import {
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_BEGIN,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_SUCCESS,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_FAILURE,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadExternalDatabaseForXata(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_BEGIN,
    });
    const { projectId, version, dbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xata/${dbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_SUCCESS,
            data: res.data,
          });
          console.log('res data', res.data);
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalDatabaseForXataError() {
  return {
    type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_BEGIN:
      return {
        ...state,
        loadExternalDatabaseForXataPending: true,
        loadExternalDatabaseForXataError: null,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_SUCCESS:
      return {
        ...state,
        loadExternalDatabaseForXataPending: false,
        loadExternalDatabaseForXataError: null,
        externalDatabaseXata: action.data,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_FAILURE:
      return {
        ...state,
        loadExternalDatabaseForXataPending: false,
        loadExternalDatabaseForXataError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_XATA_DISMISS_ERROR:
      return {
        ...state,
        loadExternalDatabaseForXataError: null,
      };

    default:
      return state;
  }
}
